import {
  BoostProvider,
  BoostTask,
} from '../pages/Tasks/adapters/sponsors/boost/types/boost';

declare global {
  interface Window {
    AdexiumWidget: any;
  }
}

export class AdexiumBoostProvider implements BoostProvider {
  private adexiumWidget: any = null;
  private isInitialized = false;

  getName(): string {
    return 'adexium';
  }

  private async initializeWidget(): Promise<void> {
    if (this.isInitialized) return;

    return new Promise((resolve) => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.setupWidget();
          resolve();
        });
      } else {
        this.setupWidget();
        resolve();
      }
    });
  }

  private setupWidget(): void {
    if (!window.AdexiumWidget) {
      console.warn('AdexiumWidget не загружен');
      return;
    }

    this.adexiumWidget = new window.AdexiumWidget({
      wid: 'd192c993-a46e-4476-8d80-a87238c71cd6',
      adFormat: 'interstitial',
      isFullScreen: false,
    });

    this.adexiumWidget.on('adReceived', (ad: any) => {
      console.log('Реклама получена:', ad);
      this.adexiumWidget.displayAd(ad);
    });

    this.adexiumWidget.on('noAdFound', () => {
      console.log('Реклама не найдена');
    });

    this.adexiumWidget.on('adClosed', () => {
      console.log('Реклама закрыта пользователем');
    });

    this.adexiumWidget.on('adPlaybackCompleted', () => {
      console.log('Просмотр рекламы завершен');
    });

    this.isInitialized = true;
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    try {
      await this.initializeWidget();

      if (!this.adexiumWidget) {
        return [];
      }

      return [
        {
          id: 'adexium_interstitial',
          title: 'Показать рекламу',
          description: 'Просмотр рекламы Adexium',
          provider: 'adexium',
          onClick: () => this.startTask('adexium_interstitial'),
        },
      ];
    } catch (error) {
      console.error('Ошибка получения заданий Adexium:', error);
      return [];
    }
  }

  async startTask(
    _taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'> {
    try {
      if (!this.adexiumWidget) {
        return 'ads_not_found';
      }

      return new Promise((resolve) => {
        this.adexiumWidget.on('adReceived', () => {
          console.log('Реклама получена, ожидаем завершения просмотра...');
        });

        this.adexiumWidget.on('adPlaybackCompleted', () => {
          console.log('Просмотр рекламы завершен, награждаем пользователя');
          resolve('success');
        });

        this.adexiumWidget.on('noAdFound', () => {
          resolve('ads_not_found');
        });

        this.adexiumWidget.on('adClosed', () => {
          resolve('user_cancelled');
        });

        this.adexiumWidget.requestAd('interstitial');
      });
    } catch (error) {
      console.error('Ошибка запуска задания Adexium:', error);
      return 'ads_not_found';
    }
  }
}
